import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';

@Component({
  selector: 'app-show-info-modal',
  templateUrl: './show-info-modal.component.html',
  styleUrls: ['./show-info-modal.component.scss']
})
export class ShowInfoModalComponent implements OnInit {

  notApplicableDeliveries: Delivery[] = [];
  excludedDeliveries: Delivery[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { notApplicableDeliveries: Delivery[], excludedDeliveries?: Delivery[] },
    private dialogRef: MatDialogRef<ShowInfoModalComponent>,
  ) { 
    this.notApplicableDeliveries = this.data?.notApplicableDeliveries || [];
    this.excludedDeliveries = this.data?.excludedDeliveries || [];
  }

  async ngOnInit() {
    console.log('notApplicableDeliveries', this.notApplicableDeliveries)
    console.log('excludedDeliveries', this.excludedDeliveries)
  }

}
